import { createSelector } from "reselect";

const getOrder = state => state.data.order;

export default createSelector(getOrder, order => ({
  ...order,
}));



// WEBPACK FOOTER //
// ./src/selector/order.js